import React from 'react';

const color = {
  WORSENING: 'text-rose-300',
  IMPROVING: 'text-emerald-300',
  STABLE: 'text-slate-300',
};

const ExperienceTrendPanel = ({ trends = [] }) => (
  <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
    <h3 className="text-sm font-semibold text-slate-100">Trend Pengalaman</h3>
    <div className="mt-3 overflow-x-auto">
      <table className="min-w-full text-left text-xs text-slate-300">
        <thead>
          <tr className="text-slate-400">
            <th className="px-2 py-1">Scope</th>
            <th className="px-2 py-1">ID</th>
            <th className="px-2 py-1">Trend</th>
            <th className="px-2 py-1">Delta</th>
            <th className="px-2 py-1">Key Drivers</th>
          </tr>
        </thead>
        <tbody>
          {trends.slice(0, 20).map((item, idx) => (
            <tr key={`trend-${idx}`} className="border-t border-slate-800/70">
              <td className="px-2 py-1.5">{item.scopeType}</td>
              <td className="px-2 py-1.5">{item.scopeId}</td>
              <td className={`px-2 py-1.5 font-medium ${color[item.trendDirection] || 'text-slate-300'}`}>{item.trendDirection}</td>
              <td className="px-2 py-1.5">{item.scoreDelta}</td>
              <td className="px-2 py-1.5">{(item.keyDrivers || []).join(', ')}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {!trends.length ? <div className="px-2 py-2 text-xs text-slate-500">Belum ada trend.</div> : null}
    </div>
  </section>
);

export default ExperienceTrendPanel;
